import parse, { Element } from 'html-react-parser'
import { LinkCard } from '../crewHtmlEditor/components/linkCard'
import { sanitizeHtml } from 'utils/html'
import { CrewEntityReference } from '../crewEntityReference/crewEntityReference'
import { EntityType } from '@crew/enums/domain'
import { entityReference as entityReferenceConst } from '@crew/configs/constants'

type Props = {
  html: string
}

const entityTypeValues: string[] = Object.values(EntityType)

// 値がEntityTypeのいずれかであるかを判定する型ガード関数
const isEntityType = (value: unknown): value is EntityType =>
  typeof value === 'string' && entityTypeValues.includes(value)

export const CrewHtmlContent: React.FC<Props> = ({ html }) => {
  const options = {
    replace: (domNode: any) => {
      // 'data-linkcard'がDomに含まれていた場合は、LinkCardに置き換える
      if (domNode.attribs && domNode.attribs['data-linkcard'] !== undefined) {
        const url = domNode.attribs['data-linkcard-url']
        if (url) {
          return <LinkCard url={url} />
        }
      }

      // リンクカードではなく、'data-reference'がDomに含まれていた場合は、typeとIDを取り出し、CrewReferenceに置き換える
      const element = domNode as Element

      if (
        element.attribs &&
        element.attribs[entityReferenceConst.DATA_ATTRIBUTE.TAG_TYPE.NAME] !==
          undefined
      ) {
        const entityType =
          element.attribs[entityReferenceConst.DATA_ATTRIBUTE.ENTITY_TYPE.NAME]
        const entityRecordId =
          element.attribs[
            entityReferenceConst.DATA_ATTRIBUTE.ENTITY_RECORD_ID.NAME
          ]

        if (
          !isEntityType(entityType) ||
          typeof entityRecordId !== 'string' ||
          entityRecordId.length === 0
        ) {
          return null
        }

        return (
          <CrewEntityReference
            entityType={entityType}
            entityRecordId={entityRecordId}
          />
        )
      }
    },
  }

  return <>{parse(sanitizeHtml(html), options)}</>
}
